<template>
    <div>
        <a @click="showPopup = true">
            <slot></slot>
        </a>
        <portal to="modal" v-if="showPopup">
            <modal @close="showPopup = false">
                <template slot="header"><slot name="header"></slot></template>
                <slot name="content">CONTENT</slot>
            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from "./Modal";

export default {
    name: "Popup",
    components: {Modal},
    data: () => ({
        showPopup: false,
    }),

    mounted() {
        this.$on('close', (e) => {
            this.showPopup = false;
        });
    },
}
</script>

<style scoped>

</style>
